import { memo } from 'react'
import PropTypes from 'prop-types'

import { ConfirmationDialog } from '@collaborate-health/uikit'

const DeleteReportProviderConfirmationDialog = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title='Are you sure you want to delete this report provider?'
      dialogMessage='If you delete provider, all reports linked to this provider will also be deleted. This action is irreversible.'
      submitButtonText='Yes'
      cancelButtonText='No'
    />
  )
}

DeleteReportProviderConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default memo(DeleteReportProviderConfirmationDialog)
